<template>
  <div>
    <div class="relative bg-green-800" v-if="showBanner">
      <div class="max-w-7xl mx-auto py-3 px-3 sm:px-6 lg:px-8">
        <div class="pr-16 sm:text-center sm:px-16">
          <p class="font-medium text-white">
            <span class="inline">
              Enable the notifications to receive alerts when you receive a
              message from the customer
            </span>
            <span class="block sm:ml-2 sm:inline-block">
              <a
                class="text-white font-bold underline cursor-pointer"
                @click="enableNotifications"
              >
                Enable
                <span aria-hidden="true">&rarr;</span></a
              >
            </span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getMessaging, getToken, isSupported } from "firebase/messaging";

export default {
  data() {
    return {
      showBanner: true
    };
  },
  mounted() {
    if (!/Edg/.test(navigator.userAgent)) {
      this.isPermissionGrantedAlready();
    }
  },
  methods: {
    isPermissionGrantedAlready() {
      Notification.requestPermission().then(permission => {
        if (permission === "granted") {
          //   this.enableNotifications();
        } else {
          this.showBanner = true;
        }
      });
    },
    async enableNotifications() {
      try {
        const isMessagingSupported = await isSupported();
        if (isMessagingSupported) {
          const messaging = await getMessaging();

          let swRegistration;
          if (
            /Chrome/.test(navigator.userAgent) ||
            /Edg/.test(navigator.userAgent)
          ) {
            swRegistration = await navigator.serviceWorker.register(
              "/firebase-messaging-sw.js"
            );
            console.log("sw registeration done in chrome", swRegistration);
          }

          getToken(messaging, { vapidKey: process.env.VUE_APP_FCM_VAPID })
            .then(currentToken => {
              if (currentToken) {
                this.$store.dispatch("Inbox/updateNotificationToken", {
                  requestParams: {
                    token: currentToken
                  }
                });
                console.log("current token", currentToken);
                this.showBanner = false;
              } else {
                // Show permission request UI
                console.log(
                  "No registration token available. Request permission to generate one."
                );
                // ...
              }
            })
            .catch(err => {
              console.log("An error occurred while retrieving token. ", err);
              alert(
                "error while enabling notification, please contact support "
              );
              // ...
            });
        }
      } catch (error) {
        console.log("mesaging not initialized");
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
